module.exports = __webpack_public_path__ + "static/media/impact_force.eaac20ff.png";